const PERSIAN_SCRIPT = /[\u0600-\u06FF]/;

/**
 * Prefer API `error` only when it looks like a user-facing Persian message.
 */
export function userFacingApiError(body, fallbackFa) {
  if (!body || typeof body !== 'object') return fallbackFa;
  const err = body.error;
  if (typeof err !== 'string') return fallbackFa;
  const s = err.trim();
  if (!s || s.length > 280) return fallbackFa;
  if (PERSIAN_SCRIPT.test(s)) return s;
  return fallbackFa;
}

/**
 * Same rule for optional `message` (e.g. third-party gateways).
 */
export function userFacingGatewayMessage(body, fallbackFa) {
  if (!body || typeof body !== 'object') return fallbackFa;
  const m = body.message;
  if (typeof m !== 'string') return fallbackFa;
  const s = m.trim();
  if (!s || s.length > 280) return fallbackFa;
  if (PERSIAN_SCRIPT.test(s)) return s;
  return fallbackFa;
}

export function preferPersianText(text, fallbackFa) {
  if (typeof text !== 'string') return fallbackFa;
  const s = text.trim();
  if (!s || s.length > 280) return fallbackFa;
  if (PERSIAN_SCRIPT.test(s)) return s;
  return fallbackFa;
}

/** Returns trimmed Persian string or null (for chaining with ||). */
export function persianOrNull(text) {
  if (typeof text !== 'string') return null;
  const s = text.trim();
  if (!s || s.length > 280) return null;
  return PERSIAN_SCRIPT.test(s) ? s : null;
}

/**
 * Read JSON body from a failed response and map `error` to a safe user string.
 */
export async function userFacingMessageFromResponse(response, fallbackFa) {
  const ct = (response.headers.get('content-type') || '').toLowerCase();
  if (ct.includes('application/json')) {
    try {
      const body = await response.json();
      return userFacingApiError(body, fallbackFa);
    } catch {
      return fallbackFa;
    }
  }
  try {
    const text = await response.text();
    if (text) console.error('API non-JSON error body (truncated):', text.slice(0, 500));
  } catch {
    /* ignore */
  }
  return fallbackFa;
}
